import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionTrackingService } from '@com-delta-idp/mnx-utils';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata,
  LoginAuthWithCredentials,
  LoginAuthWithCredentialsParams,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

const fileName = 'PostWithContinueService';

@Injectable({
  providedIn: 'root'
})
export class PostWithContinueService {
  loginAuthRememberMeContinueHeader = new HttpHeaders({
    'Content-Type': 'application/vnd.pingidentity.submitContinue+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  });

  constructor(
    private utils: UtilService,
    private exceptionTracking: ExceptionTrackingService
  ) {}

  async postWithContinue(
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Promise<LoginAuthWithCredentials> {
    let body: PostWithCredentials = {};
    let loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams;
    try {
      body = {
        continue: true
      };
      loginAuthWithCredentialsParams = {
        oauthConfig: authConfig,
        flowId: flowIdValue
      };
      return await this.utils.loginAuthWithCredResponse(
        loginAuthWithCredentialsParams,
        body,
        this.loginAuthRememberMeContinueHeader
      );
    } catch (exception) {
      const exceptionMetadata: IExceptionMetadata = {
        fileName,
        methodName: 'postWithContinue',
        exceptionCategory: EXCEPTION_CATEGORY_ENUM.JS_CATCH_BLOCK,
        exceptionMessage:
          'Exception caught while calling PostWithContinueService'
      };
      const exceptionStr = exception as string;
      this.exceptionTracking.track(exceptionStr, exceptionMetadata);
      return exception as LoginAuthWithCredentials;
    }
  }
}
